import React from "react";
import { useSelector } from "react-redux";
import i18n from "i18next";

/**
 * Renders a spinner + status text on top of a box while the
 * Aidea Smart Elements decomposition job is in flight.
 *
 * Reads from the ephemeral (non-undoable) `aideaSmartElementsProcessing` slice
 * keyed by source boxId. Renders nothing if there's no active job for this box.
 */
export default function AideaSmartElementsOverlay({ boxId }) {
  const info = useSelector(
    (s) => (s.aideaSmartElementsProcessing && s.aideaSmartElementsProcessing[boxId]) || null
  );
  if (!info) return null;
  return (
    <div
      style={{
        position: "absolute",
        inset: 0,
        background: "rgba(0,0,0,0.45)",
        color: "white",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 1000,
        pointerEvents: "none",
        borderRadius: "inherit",
      }}
      role="status"
      aria-live="polite"
    >
      <div
        style={{
          width: 32,
          height: 32,
          border: "3px solid rgba(255,255,255,0.3)",
          borderTopColor: "white",
          borderRadius: "50%",
          animation: "aidea-smart-elements-spin 1s linear infinite",
        }}
      />
      <div style={{ marginTop: 8, fontSize: 12, textAlign: "center", padding: "0 8px" }}>
        {info.message || i18n.t("aideaSmartElementsProcessing")}
      </div>
      <div style={{ marginTop: 4, fontSize: 11, opacity: 0.8 }}>
        {typeof info.percent === "number" ? `${info.percent}%` : "..."}
      </div>
      <style>{`@keyframes aidea-smart-elements-spin { to { transform: rotate(360deg); } }`}</style>
    </div>
  );
}
